import { atDialect } from '../../../Components/engine/dialect';

/** Layout descriptor for the long channel's sort menu, keyed like every other surface. */
export const LONGCHANNEL_SORTING = atDialect([
  { key: 'companyName', label: 'COMPANY', isDefault: true },
  { key: 'fullName', label: 'FINANCIALMANAGER' },
  { key: 'ratingValue', label: 'RATING' },
  { key: 'exportedOn', label: 'EXPORTEDON' },
  { key: 'lastActivityCompletedOn', label: 'LASTACTIVITYCOMPLETEDON' },
]);

/**
 * Layout descriptor for the keys the long channel's search box matches typed text against.
 *
 * `fullNameSearch` is projected by the list procedure rather than mapped on the entity, so the
 * catalogue does not hold it; the editor offers it because this layout declares it.
 */
export const LONGCHANNEL_SEARCH = atDialect([
  { key: 'companyName', label: 'COMPANY' },
  { key: 'fullNameSearch', label: 'FINANCIALMANAGER' },
  { key: 'customerCode', label: 'CUSTOMERCODE' },
  { key: 'mobilePhoneNumber', label: 'MOBILE_PHONE' },
]);

/** The section whose document holds the long channel's attributes. */
export const LONGCHANNEL_SECTION = 'DEALERS';
